export const TRIAL_DAYS = 14;

export const getTrialEndDate = (fromDate = new Date()) =>
  new Date(fromDate.getTime() + TRIAL_DAYS * 24 * 60 * 60 * 1000);
